import { DialogProps } from '@material-ui/core';
import React from 'react';
import { StringModelForm } from 'framework/forms/StringModelForm';
import { ILocation, locationsCommand_patchPhone } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';

interface IProps extends DialogProps {
	location: ILocation;
	confirm: VoidFunction;
	cancel: VoidFunction;
}

export const LocationPhoneForm = ({ location, ...rest }: IProps) => {
	const strings = useLocalization();

	return (
		<StringModelForm
			label={strings.phone}
			formTitle={strings.changeWhat(strings.phone)}
			notifyMessage={strings.locationUpdated}
			submitFunction={val => locationsCommand_patchPhone({ locationId: location.id, phone: val })}
			initialValue={location.phone ?? ''}
			submitText={strings.update}
			{...rest}
		/>
	);
};
